import { ApiEndpointHandler } from '@sonar-software/sonar-http';
import { DataSecurityApplicationStatus } from '@types';

import {
	patchDataSecurityApplicationById,
	PatchDataSecurityApplicationByIdRequest
} from './patchDataSecurityApplicationById';

export type HideDataSecurityApplicationByIdRequest = Pick<PatchDataSecurityApplicationByIdRequest, 'applicationId'>;

export const hideDataSecurityApplicationById: ApiEndpointHandler<HideDataSecurityApplicationByIdRequest> =
	(request) => patchDataSecurityApplicationById({
		...request,
		status: DataSecurityApplicationStatus.Deleted
	});
